module.exports = __webpack_public_path__ + "static/media/renekaj.5956588f.gif";